import mappedItemTypes from 'services/items/mappedItemTypes';
import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import { PCW_STEPS } from '../constants';

export function HydroStep() {
    return (
        <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_HYDRO_STEP_ID}
            itemTypeIds={[mappedItemTypes.HYDRO.id, mappedItemTypes.HYDRO_PROJECT.id]}
        />
    );
}
